import { styled } from 'styled-components';
import logoY from '../../assets/logo-y.svg';
import logoRegular from '../../assets/logo-white.svg';
import React from 'react';

export const LogoImage = styled.img`
  height: 1.25rem;
  margin: 0.75rem;
`;

export interface LogoProps {
  type?: 'short' | 'regular';
}

/**
 * Displays company logo in either short or regular form.
 * @param type
 */
export const Logo: React.FC<LogoProps> = ({ type = 'regular' }) => {
  return <LogoImage src={type === 'short' ? logoY : logoRegular} alt="Logo" />;
};
